export default __webpack_public_path__ + "images/NI.a97373c.png";